<template>
  <v-container fluid>
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md4
        class="mt-5"
      >
        <v-card class="elevation-12">
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title class="text-no-wrap">Validate Game Code</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                color="accent"
                fab
                top
                @click="navigateToAdminLogin"
              >
                <v-icon>lock</v-icon>
              </v-btn>
              <span>Administrator Login</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <blockquote class="blockquote ma-2">
              Welcome to the gameshow!
              Please enter the game code cooresponding to your game session.
            </blockquote>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                prepend-icon="videogame_asset"
                name="gameCode"
                v-model="gameCode"
                label="Game Code"
                required
                :rules="gameCodeRules"
              ></v-text-field>
              <span class="error--text">{{apiMessage}}</span>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              @click="joinGame"
            >Continue</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "home",
  props:["code", "apiMessage"],
  data() {
    return {
      valid: false,
      gameCode: "",
      gameCodeRules: [v => !!v || "A game code is required"]
    };
  },
  methods: {
    joinGame() {
      if (this.$refs.form.validate()) {
        this.$router.push({
          name: "GameClient",
          params: { code: this.gameCode }
        });
      }
    },
    navigateToAdminLogin() {
      this.$router.push({
        name: "AdminLogin"
      });
    }
  },
  created(){
    if(this.code){
      this.gameCode = this.code;
    }
  }
};
</script>